import { render, staticRenderFns } from "./tableEsgStructuredDataReport.vue?vue&type=template&id=3e83a120&scoped=true"
import script from "./tableEsgStructuredDataReport.vue?vue&type=script&lang=js"
export * from "./tableEsgStructuredDataReport.vue?vue&type=script&lang=js"
import style0 from "./tableEsgStructuredDataReport.vue?vue&type=style&index=0&id=3e83a120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83a120",
  null
  
)

export default component.exports